import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconFiletypeImage24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.403 16.26l5.158-9.455a.5.5 0 01.878 0l3.266 5.987 1.374-2.138a.5.5 0 01.842 0l3.584 5.576a.5.5 0 01-.42.77H4.841a.5.5 0 01-.439-.74z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 6.5,
    r: 1.5,
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconFiletypeImage24);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;